import { render, staticRenderFns } from "./LeagueContainer.vue?vue&type=template&id=4011eed1&"
import script from "./LeagueContainer.vue?vue&type=script&lang=js&"
export * from "./LeagueContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports